<!----------------------- Компонент зміни пароля --------------------->
<template>
  <smallModal @escape="$emit('close')">
    <div class="inputs-div">
      <div class="old-password">
        <label :for="oldPassword">{{ lang['OldPassword'] }}</label>
        <b-form-input v-model="oldPassword" id="oldpass" type="password" :state="oldPass" autofocus />
        <span v-if="oldPass" @click="showOldPass" :class="isOldPassVisible ? 'icon-eye' : 'icon-eye-blocked'"></span>
      </div>
      <hr />
      <div class="new-password">
        <label :for="password">{{ lang['Password'] }}</label>
        <b-form-input v-model="password" id="newpass" type="password" :state="pass1" />
        <span v-if="pass1" @click="showNewPass" :class="isNewPassVisible ? 'icon-eye' : 'icon-eye-blocked'"></span>
      </div>
      <div class="repeat-password">
        <label :for="password2">{{ lang['RepeatPassword'] }}</label>
        <b-form-input v-model="password2" id="repeatnewpass" type="password" :state="pass2" />
        <span v-if="password2.length > 0" @click="showRepeatPass"
          :class="isRepeatPassVisible ? 'icon-eye' : 'icon-eye-blocked'"></span>
      </div>
    </div>
    <hr />
    <div class="buttons">
      <button class="btn btn-secondary" @click="cancel">{{ lang['Сancel'] }}</button>
      <button class="btn btn-success" @click="save" :disabled="!checkInputs">{{ lang['Save'] }}</button>
    </div>
  </smallModal>
</template>
<script>
import { store } from '@/store.js'; // Глобальне сховище даних
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна
import { regAPi } from '@/API.js';

const apiList = new regAPi();

export default {
  components: {
    smallModal
  },
  data() {
    return {
      oldPassword: '',
      isOldPassVisible: false,
      password: '',
      isNewPassVisible: false,
      password2: '',
      isRepeatPassVisible: false
    }
  },
  mounted() {
    keyevent.$off('enter');
    keyevent.$on('enter', () => this.save());
  },
  methods: {
    cancel() {
      this.$emit('close')
    },
    save() {
      if (this.checkInputs) {
        try {
          const obj = {
            token: store.token,
            old_password: this.oldPassword,
            new_password: this.password
          }
          apiList.rePassword(obj).then(resp => {
            if (resp.data.status === 'done') {
              window.say.message(this.lang['Saved']);
              this.$emit('close')
            } else if (resp.data.error[0] === 'pass is incorrect') {
              window.say.messageError(this.lang['WrongPassword']);
            } else {
              window.say.messageError(this.lang['Error']);
            }
          })
        } catch (err) {
          window.say.messageError(this.lang['Error']);
        }

      } else {
        window.say.messageError(this.lang['FillInAllTheFields']);
      }
    },
    showNewPass() {
      this.isNewPassVisible = !this.isNewPassVisible
      const input2 = document.getElementById('newpass');
      if (input2.getAttribute('type') == 'password') {
        input2.setAttribute('type', 'text');
      } else {
        input2.setAttribute('type', 'password');
      }
    },
    showRepeatPass() {
      this.isRepeatPassVisible = !this.isRepeatPassVisible
      const input3 = document.getElementById('repeatnewpass');

      if (input3.getAttribute('type') == 'password') {
        input3.setAttribute('type', 'text');
      } else {
        input3.setAttribute('type', 'password');
      }
    },
    showOldPass() {
      this.isOldPassVisible = !this.isOldPassVisible
      const input1 = document.getElementById('oldpass');
      if (input1.getAttribute('type') == 'password') {
        input1.setAttribute('type', 'text');
      } else {
        input1.setAttribute('type', 'password');
      }
    }
  },
  computed: {
    country() {
      return 'UA';
    },
    // Мова додатку
    lang() {
      return window.lang
    },
    oldPass() {
      return this.oldPassword.length >= 4;
    },
    pass1() {
      return this.password.length >= 4;
    },
    pass2() {
      return this.password2.length > 0 && this.password2 === this.password;
    },
    checkInputs() {
      return this.oldPass && this.pass1 && this.pass2;
    }
  }
}
</script>

<style scoped>
label::first-letter {
  text-transform: uppercase;
}

.icon-eye,
.icon-eye-blocked {
  position: absolute;
  right: 40px;
  top: 58.5%;
}

.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00C279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.btn-secondary,
.btn-success {
  width: 49%;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-success {
  background-color: #00c279;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success.disabled,
.btn-success:disabled {
  background-color: #00B26F;
  border: none;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  color: gray;
  background-color: white;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

.btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
}

.modal-lair {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.phone-container {
  width: 50%;
  background: #fff;
  padding: 15px;
  border-radius: 0.25rem;
}

@media screen and (max-width: 700px) {
  .phone-container {
    width: 90%;
  }
}
</style>